(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(67921);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PageSection; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(3411);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(85644);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(22175);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(76636);
// EXTERNAL MODULE: ./src/components/PageSection/svg/CurvedSvg.tsx
var CurvedSvg = __webpack_require__(17678);
;// CONCATENATED MODULE: ./src/components/PageSection/CurvedDivider.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  z-index: ",
        ";\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: ",
        ";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-82a6e052-0"
})(_templateObject(), function(param) {
    var theme = param.theme, dividerFill = param.dividerFill;
    if (theme.isDark) {
        return (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.dark) || (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.light) || "none";
    }
    return (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.light) || (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.dark) || "none";
}, function(param) {
    var index = param.index;
    return index;
});
var ComponentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-82a6e052-1"
})(_templateObject1(), function(param) {
    var index = param.index;
    return index + 1;
});
var CurvedDivider = function(param) {
    var index = param.index, dividerPosition = param.dividerPosition, dividerComponent = param.dividerComponent, concave = param.concave, clipFill = param.clipFill, dividerFill = param.dividerFill;
    var showConvexTop = dividerPosition === "top" && !concave;
    var showConvexBottom = dividerPosition === "bottom" && !concave;
    var showConcaveTop = dividerPosition === "top" && concave;
    var showConcaveBottom = dividerPosition === "bottom" && concave;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        index: index,
        dividerFill: dividerFill,
        children: [
            dividerComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper, {
                index: index,
                children: dividerComponent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    showConcaveTop && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurvedSvg/* ConcaveTop */.n6, {
                        clipFill: clipFill
                    }),
                    showConcaveBottom && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurvedSvg/* ConcaveBottom */.CT, {
                        clipFill: clipFill
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    showConvexTop && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurvedSvg/* ConvexTop */.Z5, {
                        clipFill: clipFill
                    }),
                    showConvexBottom && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurvedSvg/* ConvexBottom */.kZ, {
                        clipFill: clipFill
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PageSection_CurvedDivider = (CurvedDivider);

;// CONCATENATED MODULE: ./src/components/PageSection/index.tsx




function PageSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex-direction: column;\n  align-items: center;\n  z-index: ",
        ";\n  padding: ",
        ";\n"
    ]);
    PageSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PageSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: auto;\n  padding-top: 16px;\n  padding-bottom: 16px;\n\n  ",
        " {\n    padding-top: 32px;\n    padding-bottom: 32px;\n  }\n\n  ",
        " {\n    padding-top: 48px;\n    padding-bottom: 48px;\n  }\n"
    ]);
    PageSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var BackgroundColor = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    className: "page-bg"
}).withConfig({
    componentId: "sc-308e1ef1-0"
})(PageSection_templateObject(), function(param) {
    var index = param.index;
    return index - 1;
}, function(param) {
    var padding = param.padding;
    return padding;
});
var ChildrenWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-308e1ef1-1"
})(PageSection_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var PageSection = function(_param) {
    var children = _param.children, svgFill = _param.svgFill, _param_index = _param.index, index = _param_index === void 0 ? 1 : _param_index, dividerComponent = _param.dividerComponent, _param_dividerPosition = _param.dividerPosition, dividerPosition = _param_dividerPosition === void 0 ? "bottom" : _param_dividerPosition, _param_hasCurvedDivider = _param.hasCurvedDivider, hasCurvedDivider = _param_hasCurvedDivider === void 0 ? true : _param_hasCurvedDivider, _param_concaveDivider = _param.concaveDivider, concaveDivider = _param_concaveDivider === void 0 ? false : _param_concaveDivider, clipFill = _param.clipFill, dividerFill = _param.dividerFill, containerProps = _param.containerProps, innerProps = _param.innerProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "svgFill",
        "index",
        "dividerComponent",
        "dividerPosition",
        "hasCurvedDivider",
        "concaveDivider",
        "clipFill",
        "dividerFill",
        "containerProps",
        "innerProps"
    ]);
    var padding = (0,react.useMemo)(function() {
        // No curved divider
        if (!hasCurvedDivider) {
            return "48px 0";
        }
        // Bottom curved divider
        // Less bottom padding, as the divider is present there
        if (dividerPosition === "bottom") {
            return "48px 0 14px";
        }
        // Top curved divider
        // Less top padding, as the divider is present there
        if (dividerPosition === "top") {
            return "14px 0 48px";
        }
        return "48px 0";
    }, [
        dividerPosition,
        hasCurvedDivider
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, containerProps), {
        children: [
            hasCurvedDivider && dividerPosition === "top" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection_CurvedDivider, {
                svgFill: svgFill,
                index: index,
                concave: concaveDivider,
                dividerPosition: dividerPosition,
                dividerComponent: dividerComponent,
                clipFill: clipFill,
                dividerFill: dividerFill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundColor, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                index: index,
                padding: padding
            }, props), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildrenWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, innerProps), {
                    children: children
                }))
            })),
            hasCurvedDivider && dividerPosition === "bottom" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection_CurvedDivider, {
                svgFill: svgFill,
                index: index,
                concave: concaveDivider,
                dividerPosition: dividerPosition,
                dividerComponent: dividerComponent,
                clipFill: clipFill,
                dividerFill: dividerFill
            })
        ]
    }));
};
/* harmony default export */ var components_PageSection = (PageSection);


/***/ }),

/***/ 17678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ ConcaveBottom; },
/* harmony export */   "Z5": function() { return /* binding */ ConvexTop; },
/* harmony export */   "kZ": function() { return /* binding */ ConvexBottom; },
/* harmony export */   "n6": function() { return /* binding */ ConcaveTop; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3411);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22175);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 20px;\n  clip-path: url(",
        ");\n\n  background: ",
        ";\n\n  & svg {\n    display: block;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  transform: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  transform: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var sharedStyles = function(theme, clipPath, clipFill) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), clipPath, function() {
        if (theme.isDark) {
            return (clipFill === null || clipFill === void 0 ? void 0 : clipFill.dark) || (clipFill === null || clipFill === void 0 ? void 0 : clipFill.light) || theme.colors.background;
        }
        return (clipFill === null || clipFill === void 0 ? void 0 : clipFill.light) || theme.colors.background;
    });
};
var ConcaveContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP).withConfig({
    componentId: "sc-f0d6319c-0"
})(_templateObject1(), function(param) {
    var theme = param.theme, clipPath = param.clipPath, clipFill = param.clipFill;
    return sharedStyles(theme, clipPath, clipFill);
}, function(param) {
    var clipPath = param.clipPath;
    return clipPath === "#bottomConcaveCurve" ? "translate(0, -13px)" : "translate(0, 1px)";
});
var ConvexContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP).withConfig({
    componentId: "sc-f0d6319c-1"
})(_templateObject2(), function(param) {
    var theme = param.theme, clipPath = param.clipPath, clipFill = param.clipFill;
    return sharedStyles(theme, clipPath, clipFill);
}, function(param) {
    var clipPath = param.clipPath;
    return clipPath === "#bottomConvexCurve" ? "translate(0, -13px)" : "translate(0, -1px)";
});
var ConvexTop = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConvexContainer, {
        clipFill: clipFill,
        clipPath: "#topConvexCurve",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                    id: "topConvexCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M 0,1 L 0,0 L 1,0 L 1,1 C 0.75 0, .25 0, 0 1 Z"
                    })
                })
            })
        })
    });
};
var ConvexBottom = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConvexContainer, {
        clipFill: clipFill,
        clipPath: "#bottomConvexCurve",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                    id: "bottomConvexCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M 0,0 L 0,1 L 1,1 L 1,0 C .75 1, .25 1, 0 0 Z"
                    })
                })
            })
        })
    });
};
var ConcaveTop = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConcaveContainer, {
        clipFill: clipFill,
        clipPath: "#topConcaveCurve",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                    id: "topConcaveCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M 0,0 L 0,1 L 1,1 L 1,0 C .75 1, .25 1, 0 0 Z"
                    })
                })
            })
        })
    });
};
var ConcaveBottom = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConcaveContainer, {
        clipFill: clipFill,
        clipPath: "#bottomConcaveCurve",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                    id: "bottomConcaveCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M 0,1 L 0,0 L 1,0 L 1,1 C .75 0.1, .25 0.1, 0 1 Z"
                    })
                })
            })
        })
    });
};


/***/ }),

/***/ 32331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91905);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3411);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 50%;\n  bottom: 0px;\n  position: absolute;\n  right: 0px;\n  min-width: 20px;\n  min-height: 20px;\n  width: 37.5%;\n  height: 37.5%;\n  z-index: 5;\n\n  ",
        " {\n    border-width: 2px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: url('",
        "');\n  background-repeat: no-repeat;\n  background-size: cover;\n  border-radius: 50%;\n  position: relative;\n  width: 100%;\n  height: 100%;\n\n  & > img {\n    border-radius: 50%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var TeamAvatar = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-c5c8ef7c-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var AvatarWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c5c8ef7c-1"
})(_templateObject1(), function(param) {
    var bg = param.bg;
    return bg;
});
// TODO: replace with no profile avatar icon
var AvatarInactive = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-c5c8ef7c-2"
})(_templateObject2());
var ProfileAvatarWithTeam = function(param) {
    var profile = param.profile;
    var _profile_nft;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(AvatarWrapper, {
        bg: (_profile_nft = profile.nft) === null || _profile_nft === void 0 ? void 0 : _profile_nft.image.thumbnail,
        children: [
            !profile.isActive && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AvatarInactive, {}),
            profile.team && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TeamAvatar, {
                src: "/images/teams/".concat(profile.team.images.alt),
                alt: profile.team.name
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProfileAvatarWithTeam);


/***/ }),

/***/ 85264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87394);
/* harmony import */ var state_user_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38497);


var useGetUsernameWithVisibility = function(profile) {
    var _useUserUsernameVisibility = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,state_user_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useUserUsernameVisibility */ .Pn)(), 2), userUsernameVisibility = _useUserUsernameVisibility[0], setUserUsernameVisibility = _useUserUsernameVisibility[1];
    return {
        usernameWithVisibility: (profile === null || profile === void 0 ? void 0 : profile.username) && (userUsernameVisibility ? profile === null || profile === void 0 ? void 0 : profile.username : "\uD83D\uDC30\uD83D\uDC30\uD83D\uDC30\uD83D\uDC30\uD83D\uDC30\uD83D\uDC30"),
        userUsernameVisibility: userUsernameVisibility,
        setUserUsernameVisibility: setUserUsernameVisibility
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetUsernameWithVisibility);


/***/ }),

/***/ 67921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/swr/core/dist/index.mjs
var dist = __webpack_require__(3255);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-jsx/style.js
var style = __webpack_require__(70784);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(3411);
// EXTERNAL MODULE: ./src/components/PageSection/index.tsx + 1 modules
var PageSection = __webpack_require__(88987);
// EXTERNAL MODULE: ../../node_modules/wagmi/dist/wagmi.esm.js + 25 modules
var wagmi_esm = __webpack_require__(51523);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(84252);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(76636);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(42617);
// EXTERNAL MODULE: ../../packages/localization/src/index.tsx + 6 modules
var src = __webpack_require__(77561);
// EXTERNAL MODULE: ./src/hooks/useActiveChainId.ts
var useActiveChainId = __webpack_require__(15112);
// EXTERNAL MODULE: ../../packages/swap-sdk/dist/index.mjs + 1 modules
var swap_sdk_dist = __webpack_require__(90902);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(85644);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(87014);
// EXTERNAL MODULE: ../../packages/uikit/src/components/NextLink/NextLink.tsx
var NextLink = __webpack_require__(78005);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(60796);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(95457);
// EXTERNAL MODULE: ../../node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(38421);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ./public/images/home/lunar-bunny/astronaut-bunny.png
/* harmony default export */ var astronaut_bunny = ({"src":"/_next/static/media/astronaut-bunny.56396fa4.png","height":550,"width":533,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA9UlEQVR42mNAB9cnMWi+O6QT+/9nDgdYoPniBxaLc/85//9nYHbvmT1t2/pJb+8db/zFwMDADlZQc/mHZfLl/wUnrh2ILGkt/69RPO1/9pSli5Xf/ZesPf9Fl6Ht/Bsp5/v/tU6d3+ZXWZ/2nyFryv/8GTvXzX34Iy734p8iBjCYtkv+yZnE5pae/P8Mnl2/psyf///2lUWpcIdN2TBv65tzzf/Przf7n9jQ/n/akjXv/t9hEIMr+HDCtPPNscz/x+Y77dq7LvX/nnUxHw9tZRAAS366Hc/2/38Q28lZDDIzGxi4Ni1kyNk0n8Hxytk0VgYGBgYAXox0jRe2qPAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(22175);
;// CONCATENATED MODULE: ./src/views/Home/components/CompositeImage.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: translate(0,  0px);\n  }\n  50% {\n    transform: translate(",
        ", ",
        ");\n  }\n  to {\n    transform: translate(0, 0px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  max-height: ",
        ";\n\n  & :nth-child(2) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 1s;\n  }\n\n  & :nth-child(3) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 0.66s;\n  }\n\n  & :nth-child(4) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 0.33s;\n  }\n\n  & :nth-child(5) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 0s;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: ",
        ";\n  visibility: hidden;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  img {\n    max-height: 100%;\n    width: auto;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var floatingAnim = function(x, y) {
    return (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject(), x, y);
};
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.ZP).withConfig({
    componentId: "sc-dd92527b-0"
})(_templateObject1(), function(param) {
    var maxHeight = param.maxHeight;
    return maxHeight;
}, floatingAnim("3px", "15px"), floatingAnim("5px", "10px"), floatingAnim("6px", "5px"), floatingAnim("4px", "12px"));
var DummyImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-dd92527b-1"
})(_templateObject2(), function(param) {
    var maxHeight = param.maxHeight;
    return maxHeight;
});
var ImageWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.ZP).withConfig({
    componentId: "sc-dd92527b-2"
})(_templateObject3());
var Resolution;
(function(Resolution) {
    Resolution["MD"] = "1.5x";
    Resolution["LG"] = "2x";
})(Resolution || (Resolution = {}));
var getImageUrl = function(base, imageSrc, resolution) {
    var extension = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".png";
    return "".concat(base).concat(imageSrc).concat(resolution ? "@".concat(resolution).concat(extension) : extension);
};
var getSrcSet = function(base, imageSrc) {
    var extension = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".png";
    return "".concat(getImageUrl(base, imageSrc, undefined, extension), " 512w,\n  ").concat(getImageUrl(base, imageSrc, Resolution.MD, extension), " 768w,\n  ").concat(getImageUrl(base, imageSrc, Resolution.LG, extension), " 1024w,");
};
var CompositeImage = function(param) {
    var path = param.path, attributes = param.attributes, _param_maxHeight = param.maxHeight, maxHeight = _param_maxHeight === void 0 ? "512px" : _param_maxHeight;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        maxHeight: maxHeight,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DummyImg, {
                srcSet: getSrcSet(path, attributes[0].src, ".webp"),
                maxHeight: maxHeight,
                loading: "lazy",
                decoding: "async",
                onError: function(e) {
                    var fallbackSrcSet = getSrcSet(path, attributes[0].src);
                    if (e.currentTarget.srcset !== "" && e.currentTarget.srcset !== fallbackSrcSet) {
                        // eslint-disable-next-line no-param-reassign
                        e.currentTarget.srcset = fallbackSrcSet;
                    } else {
                        var fallbackSrc = getImageUrl(path, attributes[0].src);
                        if (e.currentTarget.srcset !== "" && !e.currentTarget.src.endsWith(fallbackSrc)) {
                            // eslint-disable-next-line no-param-reassign
                            e.currentTarget.srcset = "";
                            // eslint-disable-next-line no-param-reassign
                            e.currentTarget.src = fallbackSrc;
                        }
                    }
                }
            }),
            attributes.map(function(image) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        srcSet: getSrcSet(path, image.src, ".webp"),
                        alt: image.alt,
                        onError: function(e) {
                            var fallbackSrcSet = getSrcSet(path, image.src);
                            if (e.currentTarget.srcset !== "" && e.currentTarget.srcset !== fallbackSrcSet) {
                                // eslint-disable-next-line no-param-reassign
                                e.currentTarget.srcset = fallbackSrcSet;
                            } else {
                                var fallbackSrc = getImageUrl(path, image.src);
                                if (e.currentTarget.srcset !== "" && !e.currentTarget.src.endsWith(fallbackSrc)) {
                                    // eslint-disable-next-line no-param-reassign
                                    e.currentTarget.srcset = "";
                                    // eslint-disable-next-line no-param-reassign
                                    e.currentTarget.src = fallbackSrc;
                                }
                            }
                        }
                    })
                }, image.src);
            })
        ]
    });
};
/* harmony default export */ var components_CompositeImage = (CompositeImage);

// EXTERNAL MODULE: ./src/views/Home/components/SlideSvg.tsx
var SlideSvg = __webpack_require__(2076);
;// CONCATENATED MODULE: ./src/views/Home/components/Hero.tsx


function Hero_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: translate(0,  0px);\n  }\n  50% {\n    transform: translate(-5px, -5px);\n  }\n  to {\n    transform: translate(0, 0px);\n  }\n"
    ]);
    Hero_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Hero_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    opacity: 0.9;\n  }\n  50% {\n    opacity: 0.1;\n  }\n  to {\n    opacity: 0.9;\n  }\n"
    ]);
    Hero_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Hero_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: -1;\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  bottom: 0px;\n  left: 0px;\n"
    ]);
    Hero_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Hero_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 100%;\n  bottom: -3px;\n"
    ]);
    Hero_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  animation: ",
        " 3.5s ease-in-out infinite;\n  will-change: transform;\n  > span {\n    overflow: visible !important; // make sure the next-image pre-build blur image not be cropped\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  & :nth-child(2) {\n    animation: ",
        " 2s ease-in-out infinite;\n    animation-delay: 1s;\n  }\n\n  & :nth-child(3) {\n    animation: ",
        " 5s ease-in-out infinite;\n    animation-delay: 0.66s;\n  }\n\n  & :nth-child(4) {\n    animation: ",
        " 2.5s ease-in-out infinite;\n    animation-delay: 0.33s;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}











var flyingAnim = function() {
    return (0,styled_components_browser_esm/* keyframes */.F4)(Hero_templateObject());
};
var fading = function() {
    return (0,styled_components_browser_esm/* keyframes */.F4)(Hero_templateObject1());
};
var BgWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-809ffa94-0"
})(Hero_templateObject2());
var InnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-809ffa94-1"
})(Hero_templateObject3());
var BunnyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-809ffa94-2"
})(_templateObject4(), flyingAnim);
var StarsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-809ffa94-3"
})(_templateObject5(), fading, fading, fading);
var starsImage = {
    path: "/images/home/lunar-bunny/",
    attributes: [
        {
            src: "star-l",
            alt: "3D Star"
        },
        {
            src: "star-r",
            alt: "3D Star"
        },
        {
            src: "star-top-r",
            alt: "3D Star"
        }
    ]
};
var Hero = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var _useAccount = (0,wagmi_esm/* useAccount */.mA)(), account = _useAccount.address;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (0,jsx_runtime.jsx)((style_default()), {
                id: "6121583af5358379",
                children: '.slide-svg-dark{display:none}.slide-svg-light{display:block}[data-theme="dark"] .slide-svg-dark{display:block}[data-theme="dark"] .slide-svg-light{display:none}.overflow-wrap{overflow-wrap:break-word}'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BgWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideSvg/* SlideSvgDark */.U, {
                            className: "slide-svg-dark",
                            width: "100%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideSvg/* SlideSvgLight */.s, {
                            className: "slide-svg-light",
                            width: "100%"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                position: "relative",
                flexDirection: [
                    "column-reverse",
                    null,
                    null,
                    "row"
                ],
                alignItems: [
                    "normal",
                    null,
                    null,
                    "center"
                ],
                justifyContent: "center",
                mt: [
                    account ? "280px" : "50px",
                    null,
                    0
                ],
                id: "homepage-hero",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flex: "1",
                        flexDirection: "column",
                        className: "overflow-wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                scale: "xxl",
                                color: "secondary",
                                mb: "24px",
                                children: t("Styleo Dex DECENTRALIZED CRYPTO EXCHANGE")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                scale: "md",
                                mb: "24px",
                                children: t("Trade, earn, and win crypto on the most popular decentralized platform in the world.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                children: [
                                    !account && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                                        mr: "8px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                        to: "/swap",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: !account ? "secondary" : "primary",
                                            children: t("Trade Now")
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        height: [
                            "192px",
                            null,
                            null,
                            "100%"
                        ],
                        width: [
                            "192px",
                            null,
                            null,
                            "100%"
                        ],
                        flex: [
                            null,
                            null,
                            null,
                            "1"
                        ],
                        mb: [
                            "24px",
                            null,
                            null,
                            "0"
                        ],
                        position: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BunnyWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: astronaut_bunny,
                                    priority: true,
                                    placeholder: "blur",
                                    alt: t("Lunar bunny")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompositeImage, (0,src_object_spread/* default */.Z)({}, starsImage))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Hero = (Hero);

;// CONCATENATED MODULE: ./public/images/home/images/registration.png
/* harmony default export */ var registration = ({"src":"/_next/static/media/registration.1edbb143.png","height":199,"width":230,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAA4ElEQVR42mOAAfm90xkLlzxmZEAHcRcesfSd/c8G48+8+V+8+8Z/ScNjK60Zju/UY+i59F+o9OqfSLUz272VDyzIZD590s/p1PG8rONzmi+ft9FmYLh3TDD44KaMjK0LKrLWz1y3JS+9muHAira8g1PfPb7I4MuQs2+jwE2RsJa5rY17A9bPPvCIwf1I9bQJbwIPz3z94hyDK8O1sGz76zr+t+ZPqD6at2XC0Ruerrenzqr60XC4+fnj0wweDNf3WEdfWWEy8eROh7JDR1zTru6QD7lwiMvxyjEGo+un1XgBNydnL+vT5x4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./public/images/home/images/earn.png
/* harmony default export */ var earn = ({"src":"/_next/static/media/earn.71e77acd.png","height":240,"width":234,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABE0lEQVR4nAEIAff+AdupIgHH8qL/RB88Jv35ADz7KM6/+vwJrQYGB9sbIiFbAf//AAEBZ/8j31NzsQ4O7yrw+TPX/xIrKQIECAD5Ch8tAQBJ+yJ2MuPYHg70BQINBv3t5vgDFyYT/Pv5/QS8zwWOAQAm/ymCSc3Q7fgIBpHrGf85C/oB1u///vH4/wJBC+bGAQAA/yN1Y8/U+wMHCJDmE/8A+gABUBPm/x34oQHS9fPgAW194jUq/+XE+OzfBjM50//8ASUBwtAS/ALcUASw81DNAeCvV+oABSgV7+OBACk9egDl8f0AepRDAK/gDgBAFPG0AdyjAMr69gAg/wkr1SQsEzag5GADZ6wurEHgBwf9E/Ob8GZ7CQGeSYsAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/home/images/crypto-world.png
/* harmony default export */ var crypto_world = ({"src":"/_next/static/media/crypto-world.e709f987.png","height":239,"width":257,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAA00lEQVR42mP4/5+BkYGBgeHJjvIFH3c2TgexTyxwjv58wizr/0cGTgaGxr1A4j/zna1dNktOpXQwfGdgfbPf8/CVQw3/GRon8jJUzD26rHXZlXeeyxauNV+1/r9zze0H59dMt129v9mQwec/M0P+5IPmVZP2VbvtivofPnXjf6+aM/81py6KZkAHLjv8OyzqdtyznpS7vO3Ug8PNp77cYmAIYmMoOfyCo/zS75zuC//lYIp7jn+urj/0ciMDAwMTAwiUXf7FFXrjJBuIPf1DEROyyQAQglw1SaKwYwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./public/images/home/images/crypto-exchange.png
/* harmony default export */ var crypto_exchange = ({"src":"/_next/static/media/crypto-exchange.095dc626.png","height":223,"width":256,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAA8klEQVR4nAHnABj/Af//AATjuWlGf9x5pdnwHRAbBQD8HhIABPcL/TYFAADLAeWkML/++tBA4fuEAG/TUgAO/Pz/IxkKAQ8iHELU9Qe/AeCdJv8D/9oA+f8s/3HGZwDh7v3/AhwqAtAoRTSoJd3NAequMWT49ftqt+lyLJzePQUkCQP+JBgBAlEsrHMxSHWgAb2hnwBDH2AQOa2l5gPd0gnl8QL/sWuo/yApVwLv7a2FAQCC/wAsD9wcAufs3HsR9gcKBwX/NTOmAPACHwF75CV/ARmO3QAyCQATtfQB1lcXCBQKBgf67+zlBWAdtnBQEV+rVRdkbqTUAFwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./src/views/Home/components/SalesSection/data.ts




var swapSectionData = function(t) {
    return {
        headingText: t("TRADE ANYTHING. NO REGISTRATION, NO HASSLE."),
        bodyText: t("Trade any token on BNB Smart Chain in seconds, just by connecting your wallet."),
        reverse: false,
        primaryButton: {
            to: "/swap",
            text: t("Trade Now"),
            external: false
        },
        secondaryButton: {
            to: "https://docs.pancakeswap.finance/",
            text: t("Learn"),
            external: true
        },
        images: {
            src: registration
        }
    };
};
var earnSectionData = function(t) {
    return {
        headingText: t("EARN PASSIVE INCOME WITH CRYPTO."),
        bodyText: t("Styleo Dex makes it easy to make your crypto work for you."),
        reverse: true,
        primaryButton: {
            to: "/farms",
            text: t("Explore"),
            external: false
        },
        secondaryButton: {
            to: "https://docs.pancakeswap.finance/products/yield-farming",
            text: t("Learn"),
            external: true
        },
        images: {
            src: earn
        }
    };
};
var cakeSectionData = function(t) {
    return {
        headingText: t("CRYPTO MAKES OUR WORLD GO ROUND."),
        bodyText: t("Styleo Coin is at the heart of the PancakeSwap ecosystem. Buy it, win it, farm it, spend it, stake it... heck, you can even vote with it!"),
        reverse: false,
        primaryButton: {
            to: "/swap?outputCurrency=0xd9361d306A9e9A43f5883a064038220EF0D46fB0&chainId=56",
            text: t("Buy STC"),
            external: false
        },
        secondaryButton: {
            to: "https://docs.pancakeswap.finance/tokenomics/cake",
            text: t("Learn"),
            external: true
        },
        images: {
            src: crypto_exchange
        }
    };
};
var rateSectionData = function(t) {
    return {
        headingText: t("BEST RATES CRYPTO EXCHANGE"),
        bodyText: t("We work with multiple cryptocurrency trading platforms and exchange partners to guarantee the best rates to our clients"),
        reverse: false,
        primaryButton: {
            to: "/swap?outputCurrency=0xd9361d306A9e9A43f5883a064038220EF0D46fB0&chainId=56",
            text: t("Buy STC"),
            external: false
        },
        secondaryButton: {
            to: "https://docs.pancakeswap.finance/tokenomics/cake",
            text: t("Learn"),
            external: true
        },
        images: {
            src: crypto_world
        }
    };
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../packages/uikit/src/theme/colors.ts
var colors = __webpack_require__(33380);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(24826);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(14393);
// EXTERNAL MODULE: ../../packages/utils/formatBalance.ts
var formatBalance = __webpack_require__(242);
// EXTERNAL MODULE: ../../node_modules/swr/immutable/dist/index.mjs
var immutable_dist = __webpack_require__(2303);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(53442);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(10021);
;// CONCATENATED MODULE: ./src/views/Home/components/IconCard.tsx




function IconCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: fit-content;\n  padding: 1px 1px 4px 1px;\n  box-sizing: border-box;\n\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    IconCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function IconCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 24px;\n  right: 24px;\n\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    IconCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-dafe503b-0"
})(IconCard_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var rotation = param.rotation;
    return rotation ? "transform: rotate(".concat(rotation, ");") : "";
});
var IconWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.ZP).withConfig({
    componentId: "sc-dafe503b-1"
})(IconCard_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var rotation = param.rotation;
    return rotation ? "transform: rotate(".concat(rotation, ");") : "";
});
var IconCard = function(_param) {
    var icon = _param.icon, background = _param.background, borderColor = _param.borderColor, rotation = _param.rotation, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "icon",
        "background",
        "borderColor",
        "rotation",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        background: background,
        borderBackground: borderColor,
        rotation: rotation
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                    rotation: rotation,
                    children: icon
                }),
                children
            ]
        })
    }));
};
/* harmony default export */ var components_IconCard = (IconCard);

// EXTERNAL MODULE: ../../packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(49996);
;// CONCATENATED MODULE: ./src/views/Home/components/MetricsSection/StatCardContent.tsx


var StatCardContent = function(param) {
    var headingText = param.headingText, bodyText = param.bodyText, highlightColor = param.highlightColor;
    var _useMatchBreakpoints = (0,useMatchBreakpoints/* default */.Z)(), isMobile = _useMatchBreakpoints.isMobile, isTablet = _useMatchBreakpoints.isTablet;
    var isSmallerScreen = isMobile || isTablet;
    var split = headingText.split(" ");
    var lastWord = split.pop();
    var remainingWords = split.slice(0, split.length).join(" ");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        minHeight: [
            null,
            null,
            null,
            "168px"
        ],
        minWidth: "232px",
        width: "fit-content",
        flexDirection: "column",
        justifyContent: "flex-end",
        mt: [
            null,
            null,
            null,
            "64px"
        ],
        children: [
            isSmallerScreen && remainingWords.length > 13 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                scale: "lg",
                children: remainingWords
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                scale: "xl",
                children: remainingWords
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                color: highlightColor,
                scale: "xl",
                mb: "24px",
                children: lastWord
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                children: bodyText
            })
        ]
    });
};
/* harmony default export */ var MetricsSection_StatCardContent = (StatCardContent);

// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/LogoWithText.tsx
var LogoWithText = __webpack_require__(50724);
;// CONCATENATED MODULE: ./public/images/home/images/usersicon.png
/* harmony default export */ var usersicon = ({"src":"/_next/static/media/usersicon.12b759eb.png","height":95,"width":60,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAAoklEQVR42mMIsLdg91QSXemnLPrFR11mNgMUmFeG+/7vy0/5Xx7q9R3Il2KYXpljNK+26OfG/tb/82oLXy5pq5AEK62JDdszJTPpf35o4AIGGFhZE5S2rDbi//JK2yCwwJ0lNgHPd8Z8enso4//zndFf7iy1C2a4t9L1/NMdsf+f7Un9/3Rn7P/7K10vMzxa6y73eEt49JPtMQVAOubRGncFAGQLSMo6Y7ztAAAAAElFTkSuQmCC","blurWidth":5,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/home/images/tradesicon.png
/* harmony default export */ var tradesicon = ({"src":"/_next/static/media/tradesicon.14cb2e0e.png","height":95,"width":113,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAA0klEQVR42mNAB63fUtjSX0dxwwWcD/uweN2JUAi4H2YYej3E2uhqsIvJhUDbdQwuzGAFhoc9BN0vBPkZng/0ZTjo7dN2NSSx+0aQ74/n4YpgBdFHksQYzoa6aV8K8Dp+J7T+1f6gjV8Pxlz4djY3Gm7NjnNy/u+3eB75O9vv/69Iu58/453+/yiMWQGRrZ9f11hX/uxhbPT/ixFV//cUT/2/un71/97pF36brv86lcE4b7avVsaUNUE9xz54rX5/T3H9940MO/63MOz6H+m99bcNAGggXptKFRy1AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./public/images/home/images/stakedicon.png
/* harmony default export */ var stakedicon = ({"src":"/_next/static/media/stakedicon.c7f03527.png","height":95,"width":93,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA9ElEQVR42mOYcug/Y8CRt/wMQGB0J1aw63yM+X8GTwkGGHDSsBZ2Wv7yOMPDa5aiL4yjgs5FRu1bFtT93zkg5NCMaGYGPwYGMd0Vzx8u2nbad+5chhyTS6GfZZ9GbfzPEMO5tyeGg6GMQUeCYdP7c9ey5k29VOb4guF2zJvs81GnvruGTPvfGwpS4CvJsOXjqTuhtd03MxnuM9xReZJ2RvHid13dS//r8vgYMhkcxNQ3v3/Tvfr+w7mL9v+XP3fmn/+xq5/7Vt97F3Tw9wYGVwYGFt+Nb8I4Tv9PYDjz3zV4+39zy93/tRhu/ZfXOfBPkoEQAACCu2p2kvJnkQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/views/Home/components/MetricsSection/index.tsx
















var Stats = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var _useSWRImmutable = (0,immutable_dist/* default */.Z)("tvl"), tvl = _useSWRImmutable.data;
    var _useSWRImmutable1 = (0,immutable_dist/* default */.Z)("totalTx30Days"), txCount = _useSWRImmutable1.data;
    var _useSWRImmutable2 = (0,immutable_dist/* default */.Z)("addressCount30Days"), addressCount = _useSWRImmutable2.data;
    var trades = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(txCount);
    var users = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(addressCount);
    var tvlString = tvl ? (0,formatBalance/* formatLocalisedCompactNumber */.uI)(tvl) : "-";
    var tvlText = t("And those users are now entrusting the platform with over $%tvl% in funds.", {
        tvl: tvlString
    });
    var _tvlText_split = (0,_sliced_to_array/* default */.Z)(tvlText.split(tvlString), 2), entrusting = _tvlText_split[0], inFunds = _tvlText_split[1];
    var UsersCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: usersicon,
            priority: true,
            placeholder: "blur",
            alt: t("Lunar bunny")
        })
    };
    var TradesCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: tradesicon,
            priority: true,
            placeholder: "blur",
            alt: t("Lunar bunny")
        })
    };
    var StakedCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: stakedicon,
            priority: true,
            placeholder: "blur",
            alt: t("Lunar bunny")
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flexDirection: "column",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            flexDirection: [
                "column-reverse",
                null,
                null,
                "row"
            ],
            alignItems: [
                "center",
                null,
                null,
                "center"
            ],
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    height: [
                        "192px",
                        null,
                        null,
                        "100%"
                    ],
                    width: [
                        "192px",
                        null,
                        null,
                        "100%"
                    ],
                    // flex={[null, null, null, '1']}
                    mb: [
                        "24px",
                        null,
                        null,
                        "0"
                    ],
                    display: "contents !important",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            flexDirection: [
                                "column-reverse",
                                null,
                                null,
                                "row"
                            ],
                            alignItems: [
                                "flex-end",
                                null,
                                null,
                                "center"
                            ],
                            justifyContent: "center",
                            mr: 10,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                background: colors/* darkColors.input */._.input
                            }, StakedCardData), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsSection_StatCardContent, {
                                    headingText: t("$%tvl% staked", {
                                        tvl: tvlString
                                    }),
                                    bodyText: t("Total Value Locked"),
                                    highlightColor: theme.colors.failure
                                })
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            flexDirection: "column",
                            flex: "1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    background: colors/* darkColors.input */._.input
                                }, UsersCardData), {
                                    mr: [
                                        null,
                                        null,
                                        null,
                                        "16px"
                                    ],
                                    mb: [
                                        "16px",
                                        null,
                                        null,
                                        "0"
                                    ],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsSection_StatCardContent, {
                                        headingText: t("%users% users", {
                                            users: users
                                        }),
                                        bodyText: t("in the last 30 days"),
                                        highlightColor: theme.colors.secondary
                                    })
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    background: colors/* darkColors.input */._.input
                                }, TradesCardData), {
                                    mr: [
                                        null,
                                        null,
                                        null,
                                        "16px"
                                    ],
                                    mb: [
                                        "16px",
                                        null,
                                        null,
                                        "0"
                                    ],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsSection_StatCardContent, {
                                        headingText: t("%trades% trades", {
                                            trades: trades
                                        }),
                                        bodyText: t("made in the last 30 days"),
                                        highlightColor: theme.colors.primary
                                    })
                                }))
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    flexDirection: "column",
                    alignItems: "center",
                    flex: "1",
                    ml: [
                        null,
                        null,
                        null,
                        "64px"
                    ],
                    mr: [
                        null,
                        null,
                        null,
                        "64px"
                    ],
                    alignSelf: [
                        "flex-start",
                        null,
                        null,
                        "center"
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoWithText/* default */.Z, {
                            width: "198px",
                            mb: "44px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            textAlign: "center",
                            scale: "xl",
                            children: t("Used by millions.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            textAlign: "center",
                            scale: "xl",
                            mb: "32px",
                            children: t("Trusted with billions.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            textAlign: "center",
                            color: "textSubtle",
                            children: t("Styleo Dex has the most users of any decentralized platform, ever.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            flexWrap: "wrap",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                display: "inline",
                                textAlign: "center",
                                color: "textSubtle",
                                mb: "20px",
                                children: [
                                    entrusting,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: tvl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: tvlString
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            display: "inline-block",
                                            height: 16,
                                            width: 70,
                                            mt: "2px"
                                        })
                                    }),
                                    inFunds
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            textAlign: "center",
                            color: "textSubtle",
                            bold: true,
                            mb: "32px",
                            children: t("Will you join them?")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var MetricsSection = (Stats);

// EXTERNAL MODULE: ../../packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(63151);
// EXTERNAL MODULE: ./src/views/Home/components/ColoredWordHeading.tsx
var ColoredWordHeading = __webpack_require__(71446);
;// CONCATENATED MODULE: ./src/views/Home/components/SalesSection/index.tsx




var borderstyle = {
    border: "2px solid #fff",
    borderRadius: "50px"
};
var SalesSection = function(props) {
    var headingText = props.headingText, bodyText = props.bodyText, primaryButton = props.primaryButton, images = props.images;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        children: [
            images ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: images.src,
                priority: true,
                width: 230,
                height: 199
            }) : "",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredWordHeading/* default */.Z, {
                text: headingText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                mb: "24px",
                children: bodyText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    mr: "16px",
                    style: borderstyle,
                    children: primaryButton.external ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        external: true,
                        href: primaryButton.to,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "card",
                            bold: true,
                            fontSize: "16px",
                            children: primaryButton.text
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                        to: primaryButton.to,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "card",
                            bold: true,
                            fontSize: "16px",
                            children: primaryButton.text
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_SalesSection = (SalesSection);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Balance/Balance.tsx
var Balance = __webpack_require__(93561);
// EXTERNAL MODULE: ./src/config/abi/cake.json
var cake = __webpack_require__(93361);
// EXTERNAL MODULE: ../../packages/tokens/src/56.ts
var _56 = __webpack_require__(59593);
// EXTERNAL MODULE: ../../packages/hooks/src/index.ts + 12 modules
var hooks_src = __webpack_require__(16929);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 1 modules
var hooks = __webpack_require__(79524);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(60242);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(81254);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var constants = __webpack_require__(57535);
// EXTERNAL MODULE: ./src/config/abi/cakeVaultV2.json
var cakeVaultV2 = __webpack_require__(93293);
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(10528);
;// CONCATENATED MODULE: ./src/views/Home/components/CakeDataRow.tsx




function CakeDataRow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  ",
        "\n\n  ",
        "\n"
    ]);
    CakeDataRow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CakeDataRow_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-gap: 16px 8px;\n  margin-top: 24px;\n  grid-template-columns: repeat(2, auto);\n  grid-template-areas:\n    'a d'\n    'b e'\n    'c f';\n\n  ",
        " {\n    grid-gap: 16px;\n  }\n\n  ",
        " {\n    grid-template-areas:\n      'a b c'\n      'd e f';\n    grid-gap: 32px;\n    grid-template-columns: repeat(3, auto);\n  }\n"
    ]);
    CakeDataRow_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
















var StyledColumn = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d5fa3b53-0"
})(CakeDataRow_templateObject(), function(param) {
    var noMobileBorder = param.noMobileBorder, theme = param.theme;
    return noMobileBorder ? "".concat(theme.mediaQueries.md, " {\n           padding: 0 16px;\n           border-left: 1px ").concat(theme.colors.inputSecondary, " solid;\n         }\n       ") : "border-left: 1px ".concat(theme.colors.inputSecondary, " solid;\n         padding: 0 8px;\n         ").concat(theme.mediaQueries.sm, " {\n           padding: 0 16px;\n         }\n       ");
}, function(param) {
    var noDesktopBorder = param.noDesktopBorder, theme = param.theme;
    return noDesktopBorder && "".concat(theme.mediaQueries.md, " {\n           padding: 0;\n           border-left: none;\n         }\n       ");
});
var Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d5fa3b53-1"
})(CakeDataRow_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var emissionsPerBlock = 11.16;
/**
 * User (Planet Finance) built a contract on top of our original manual CAKE pool,
 * but the contract was written in such a way that when we performed the migration from Masterchef v1 to v2, the tokens were stuck.
 * These stuck tokens are forever gone (see their medium post) and can be considered out of circulation."
 * https://planetfinanceio.medium.com/pancakeswap-works-with-planet-to-help-cake-holders-f0d253b435af
 * https://twitter.com/PancakeSwap/status/1523913527626702849
 * https://bscscan.com/tx/0xd5ffea4d9925d2f79249a4ce05efd4459ed179152ea5072a2df73cd4b9e88ba7
 */ var planetFinanceBurnedTokensWei = bignumber/* BigNumber.from */.O$.from("637407922445268000000000");
var cakeVaultAddress = (0,addressHelpers/* getCakeVaultAddress */.O9)();
var CakeDataRow = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var _useIntersectionObserver = (0,hooks_src/* useIntersectionObserver */.S1)(), observerRef = _useIntersectionObserver.observerRef, isIntersecting = _useIntersectionObserver.isIntersecting;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), loadData = _useState[0], setLoadData = _useState[1];
    var _useSWR = (0,dist/* default */.ZP)(loadData ? [
        "cakeDataRow"
    ] : null, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var totalSupplyCall, burnedTokenCall, cakeVaultCall, _ref, _ref_, totalSupply, _ref_1, burned, _ref_2, totalLockedAmount, totalBurned, circulating;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    totalSupplyCall = {
                        abi: cake,
                        address: _56/* bscTokens.cake.address */.d.cake.address,
                        name: "totalSupply"
                    };
                    burnedTokenCall = {
                        abi: cake,
                        address: _56/* bscTokens.cake.address */.d.cake.address,
                        name: "balanceOf",
                        params: [
                            "0x000000000000000000000000000000000000dEaD"
                        ]
                    };
                    cakeVaultCall = {
                        abi: cakeVaultV2,
                        address: cakeVaultAddress,
                        name: "totalLockedAmount"
                    };
                    return [
                        4,
                        (0,multicall/* multicallv3 */.OF)({
                            calls: [
                                totalSupplyCall,
                                burnedTokenCall,
                                cakeVaultCall
                            ],
                            allowFailure: true
                        })
                    ];
                case 1:
                    _ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), _ref_ = (0,_sliced_to_array/* default */.Z)(_ref[0], 1), totalSupply = _ref_[0], _ref_1 = (0,_sliced_to_array/* default */.Z)(_ref[1], 1), burned = _ref_1[0], _ref_2 = (0,_sliced_to_array/* default */.Z)(_ref[2], 1), totalLockedAmount = _ref_2[0];
                    totalBurned = planetFinanceBurnedTokensWei.add(burned);
                    circulating = totalSupply.sub(totalBurned.add(totalLockedAmount));
                    return [
                        2,
                        {
                            cakeSupply: totalSupply && burned ? +(0,formatBalance/* formatBigNumber */.dp)(totalSupply.sub(totalBurned)) : 0,
                            burnedBalance: burned ? +(0,formatBalance/* formatBigNumber */.dp)(totalBurned) : 0,
                            circulatingSupply: circulating ? +(0,formatBalance/* formatBigNumber */.dp)(circulating) : 0
                        }
                    ];
            }
        });
    }), {
        refreshInterval: constants/* SLOW_INTERVAL */.KI
    }), tmp = _useSWR.data, _ref = tmp === void 0 ? {
        cakeSupply: 0,
        burnedBalance: 0,
        circulatingSupply: 0
    } : tmp, cakeSupply = _ref.cakeSupply, burnedBalance = _ref.burnedBalance, circulatingSupply = _ref.circulatingSupply;
    var cakePriceBusd = (0,hooks/* usePriceCakeBusd */.Iu)();
    var mcap = cakePriceBusd.times(circulatingSupply);
    var mcapString = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(mcap.toNumber());
    (0,react.useEffect)(function() {
        if (isIntersecting) {
            setLoadData(true);
        }
    }, [
        isIntersecting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                style: {
                    gridArea: "a"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: t("Circulating Supply")
                    }),
                    circulatingSupply ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        decimals: 0,
                        lineHeight: "1.1",
                        fontSize: "24px",
                        bold: true,
                        value: 5000000
                    }) // value={circulatingSupply}
                     : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        height: 24,
                        width: 126,
                        my: "4px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledColumn, {
                noMobileBorder: true,
                style: {
                    gridArea: "b"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: t("Total supply")
                    }),
                    cakeSupply ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        decimals: 0,
                        lineHeight: "1.1",
                        fontSize: "24px",
                        bold: true,
                        value: 300000000
                    }) // value={cakeSupply}
                     : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: observerRef
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                height: 24,
                                width: 126,
                                my: "4px"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledColumn, {
                noMobileBorder: true,
                style: {
                    gridArea: "c"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: t("Max Supply")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        decimals: 0,
                        lineHeight: "1.1",
                        fontSize: "24px",
                        bold: true,
                        value: 300000000
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledColumn, {
                noDesktopBorder: true,
                style: {
                    gridArea: "d"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: t("Market cap")
                    }),
                    (mcap === null || mcap === void 0 ? void 0 : mcap.gt(0)) && mcapString ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        scale: "lg",
                        children: t("$%marketCap%", {
                            marketCap: mcapString
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        height: 24,
                        width: 126,
                        my: "4px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledColumn, {
                style: {
                    gridArea: "e"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: t("Current emissions")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        scale: "lg",
                        children: t("%cakeEmissions%/block", {
                            cakeEmissions: emissionsPerBlock
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CakeDataRow = (CakeDataRow);

// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Svg.tsx
var Svg_Svg = __webpack_require__(39017);
;// CONCATENATED MODULE: ./src/views/Home/components/WedgeSvgs.tsx



function WedgeSvgs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: -1;\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  right: 0px;\n  top: 0px;\n"
    ]);
    WedgeSvgs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WedgeSvgs_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  width: 100%;\n  ",
        ";\n\n  svg {\n    fill: ",
        ";\n    width: ",
        ";\n    height: 100%;\n    max-height: 48px;\n  }\n"
    ]);
    WedgeSvgs_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var OuterWedgeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cbf3a528-0"
})(WedgeSvgs_templateObject());
var InnerWedgeWrapper = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    className: "inner-wedge"
}).withConfig({
    componentId: "sc-cbf3a528-1"
})(WedgeSvgs_templateObject1(), function(param) {
    var top = param.top;
    return top ? "top: 0px" : "bottom: 0px";
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var width = param.width;
    return width || "100%";
});
var WedgeTopLeft = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg_Svg/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 1660 48"
    }, props), {
        preserveAspectRatio: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1660 48C1139.02 46.1887 336.256 15.2453 0 0H1660V48Z"
        })
    }));
};
var WedgeTopRight = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 1660 48"
    }, props), {
        preserveAspectRatio: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M-346 48C174.985 46.1887 977.744 15.2453 1314 0H-346V48Z"
        })
    }));
};
var WedgeBottomRight = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 1660 48"
    }, props), {
        preserveAspectRatio: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M0 0C520.985 1.81132 1323.74 32.7547 1660 48H0V0Z"
        })
    }));
};
var WedgeBottomLeft = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 1660 48"
    }, props), {
        preserveAspectRatio: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M1660 0C1139.02 1.81132 336.256 32.7547 0 48H1660V0Z"
        })
    }));
};

// EXTERNAL MODULE: ../../packages/uikit/src/contexts/ToastsContext/useToast.ts
var useToast = __webpack_require__(79500);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/ArrowForward.tsx
var ArrowForward = __webpack_require__(57902);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(95620);
// EXTERNAL MODULE: ../../node_modules/bignumber.js/bignumber.js
var bignumber_js_bignumber = __webpack_require__(6391);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber_js_bignumber);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 1 modules
var Toast = __webpack_require__(86054);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(90395);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(38497);
// EXTERNAL MODULE: ./src/utils/calls/index.ts + 2 modules
var calls = __webpack_require__(62217);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(16816);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(90327);
// EXTERNAL MODULE: ./src/config/abi/masterchef.json
var masterchef = __webpack_require__(84951);
// EXTERNAL MODULE: ../../packages/farms/constants/index.ts
var farms_constants = __webpack_require__(30231);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 2 modules
var useContract = __webpack_require__(56521);
// EXTERNAL MODULE: ./src/utils/verifyBscNetwork.ts
var verifyBscNetwork = __webpack_require__(15241);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useBCakeProxyContractAddress.ts
var useBCakeProxyContractAddress = __webpack_require__(70688);
// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/helpers/splitProxyFarms.ts
var splitProxyFarms = __webpack_require__(56835);
;// CONCATENATED MODULE: ./src/views/Home/hooks/useFarmsWithBalance.tsx


















var useFarmsWithBalance = function() {
    var _useActiveWeb3React = (0,useActiveWeb3React/* default */.Z)(), account = _useActiveWeb3React.account, chainId = _useActiveWeb3React.chainId;
    var _useFarmsLength = (0,hooks/* useFarmsLength */.f5)(), poolLength = _useFarmsLength.data;
    var proxyAddress = (0,useBCakeProxyContractAddress/* useBCakeProxyContractAddress */.A)(account, chainId).proxyAddress;
    var bCakeProxy = (0,useContract/* useBCakeProxyContract */.DE)(proxyAddress);
    var masterChefContract = (0,useContract/* useMasterchef */.y8)();
    var getFarmsWithBalances = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(farms, accountToCheck, contract) {
            var calls, rawResults, results, farmsWithBalances, totalEarned;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        calls = farms.map(function(farm) {
                            return {
                                address: masterChefContract.address,
                                name: "pendingCake",
                                params: [
                                    farm.pid,
                                    accountToCheck
                                ]
                            };
                        });
                        return [
                            4,
                            (0,multicall/* default */.ZP)(masterchef, calls)
                        ];
                    case 1:
                        rawResults = _state.sent();
                        results = farms.map(function(farm, index) {
                            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, farm), {
                                balance: new (bignumber_default())(rawResults[index])
                            });
                        });
                        farmsWithBalances = results.filter(function(balanceType) {
                            return balanceType.balance.gt(0);
                        }).map(function(farm) {
                            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, farm), {
                                contract: contract
                            });
                        });
                        totalEarned = farmsWithBalances.reduce(function(accum, earning) {
                            var earningNumber = new (bignumber_default())(earning.balance);
                            if (earningNumber.eq(0)) {
                                return accum;
                            }
                            return accum + earningNumber.div(config/* DEFAULT_TOKEN_DECIMAL */.o3).toNumber();
                        }, 0);
                        return [
                            2,
                            {
                                farmsWithBalances: farmsWithBalances,
                                totalEarned: totalEarned
                            }
                        ];
                }
            });
        });
        return function getFarmsWithBalances(farms, accountToCheck, contract) {
            return _ref.apply(this, arguments);
        };
    }();
    var _useSWR = (0,dist/* default */.ZP)(account && poolLength && chainId ? [
        account,
        "farmsWithBalance",
        chainId,
        poolLength
    ] : null, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var farmsConfig, farmsCanFetch, normalBalances, farmsWithProxy, proxyBalances;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,farms_constants.getFarmConfig)(chainId)
                    ];
                case 1:
                    farmsConfig = _state.sent();
                    farmsCanFetch = farmsConfig.filter(function(f) {
                        return poolLength > f.pid;
                    });
                    return [
                        4,
                        getFarmsWithBalances(farmsCanFetch, account, masterChefContract)
                    ];
                case 2:
                    normalBalances = _state.sent();
                    if (!(proxyAddress && (farmsCanFetch === null || farmsCanFetch === void 0 ? void 0 : farmsCanFetch.length) && (0,verifyBscNetwork/* verifyBscNetwork */.H)(chainId))) return [
                        3,
                        4
                    ];
                    farmsWithProxy = (0,splitProxyFarms/* default */.Z)(farmsCanFetch).farmsWithProxy;
                    return [
                        4,
                        getFarmsWithBalances(farmsWithProxy, proxyAddress, bCakeProxy)
                    ];
                case 3:
                    proxyBalances = _state.sent();
                    return [
                        2,
                        {
                            farmsWithStakedBalance: (0,_to_consumable_array/* default */.Z)(normalBalances.farmsWithBalances).concat((0,_to_consumable_array/* default */.Z)(proxyBalances.farmsWithBalances)),
                            earningsSum: normalBalances.totalEarned + proxyBalances.totalEarned
                        }
                    ];
                case 4:
                    return [
                        2,
                        {
                            farmsWithStakedBalance: normalBalances.farmsWithBalances,
                            earningsSum: normalBalances.totalEarned
                        }
                    ];
            }
        });
    }), {
        refreshInterval: constants/* FAST_INTERVAL */.sR
    }), tmp = _useSWR.data, _ref = tmp === void 0 ? {
        farmsWithStakedBalance: [],
        earningsSum: null
    } : tmp, farmsWithStakedBalance = _ref.farmsWithStakedBalance, earningsSum = _ref.earningsSum;
    return {
        farmsWithStakedBalance: farmsWithStakedBalance,
        earningsSum: earningsSum
    };
};
/* harmony default export */ var hooks_useFarmsWithBalance = (useFarmsWithBalance);

;// CONCATENATED MODULE: ./src/views/Home/components/UserBanner/EarningsText.tsx
var getEarningsText = function(numFarmsToCollect, hasCakePoolToCollect, earningsBusd, t) {
    var data = {
        earningsBusd: earningsBusd.toString(),
        count: numFarmsToCollect
    };
    var earningsText = t("%earningsBusd% to collect", data);
    if (numFarmsToCollect > 0 && hasCakePoolToCollect) {
        if (numFarmsToCollect > 1) {
            earningsText = t("%earningsBusd% to collect from %count% farms and CAKE pool", data);
        } else {
            earningsText = t("%earningsBusd% to collect from %count% farm and CAKE pool", data);
        }
    } else if (numFarmsToCollect > 0) {
        if (numFarmsToCollect > 1) {
            earningsText = t("%earningsBusd% to collect from %count% farms", data);
        } else {
            earningsText = t("%earningsBusd% to collect from %count% farm", data);
        }
    } else if (hasCakePoolToCollect) {
        earningsText = t("%earningsBusd% to collect from CAKE pool", data);
    }
    return earningsText;
};

;// CONCATENATED MODULE: ./src/views/Home/components/UserBanner/HarvestCard.tsx




function HarvestCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: fit-content;\n"
    ]);
    HarvestCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var HarvestCard_StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-9e16dd6d-0"
})(HarvestCard_templateObject());
var masterChefAddress = (0,addressHelpers/* getMasterChefAddress */.Oc)();
var HarvestCard = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var _useCatchTxError = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = _useCatchTxError.fetchWithCatchTxError, pendingTx = _useCatchTxError.loading;
    var _useFarmsWithBalance = hooks_useFarmsWithBalance(), farmsWithStakedBalance = _useFarmsWithBalance.farmsWithStakedBalance, farmEarningsSum = _useFarmsWithBalance.earningsSum;
    var cakePriceBusd = (0,hooks/* usePriceCakeBusd */.Iu)();
    var gasPrice = (0,user_hooks/* useGasPrice */.Fh)();
    var earningsBusd = new (bignumber_default())(farmEarningsSum).multipliedBy(cakePriceBusd);
    var numTotalToCollect = farmsWithStakedBalance.length;
    var numFarmsToCollect = farmsWithStakedBalance.filter(function(value) {
        return value.pid !== 0;
    }).length;
    var hasCakePoolToCollect = numTotalToCollect - numFarmsToCollect > 0;
    var earningsText = getEarningsText(numFarmsToCollect, hasCakePoolToCollect, earningsBusd, t);
    var _earningsText_split = (0,_sliced_to_array/* default */.Z)(earningsText.split(earningsBusd.toString()), 2), preText = _earningsText_split[0], toCollectText = _earningsText_split[1];
    var harvestAllFarms = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var i, farmWithBalance, receipt;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < farmsWithStakedBalance.length)) return [
                        3,
                        4
                    ];
                    farmWithBalance = farmsWithStakedBalance[i];
                    return [
                        4,
                        fetchWithCatchTxError(function() {
                            return (0,calls/* harvestFarm */.sA)(farmWithBalance.contract, farmWithBalance.pid, gasPrice, farmWithBalance.contract.address !== masterChefAddress ? config/* BOOSTED_FARM_GAS_LIMIT */.ZM : undefined);
                        })
                    ];
                case 2:
                    receipt = _state.sent();
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess("".concat(t("Harvested"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash,
                            children: t("Your %symbol% earnings have been sent to your wallet!", {
                                symbol: "CAKE"
                            })
                        }));
                    }
                    _state.label = 3;
                case 3:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        farmsWithStakedBalance,
        toastSuccess,
        t,
        fetchWithCatchTxError,
        gasPrice
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HarvestCard_StyledCard, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBody/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: [
                    "column",
                    null,
                    null,
                    "row"
                ],
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        alignItems: [
                            "center",
                            null,
                            null,
                            "flex-start"
                        ],
                        children: [
                            preText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mb: "4px",
                                color: "textSubtle",
                                children: preText
                            }),
                            !earningsBusd.isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                decimals: earningsBusd.gt(0) ? 2 : 0,
                                fontSize: "24px",
                                bold: true,
                                prefix: earningsBusd.gt(0) ? "~$" : "$",
                                lineHeight: "1.1",
                                value: earningsBusd.toNumber()
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                width: 96,
                                height: 24,
                                my: "2px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mb: [
                                    "16px",
                                    null,
                                    null,
                                    "0"
                                ],
                                color: "textSubtle",
                                children: toCollectText
                            })
                        ]
                    }),
                    numTotalToCollect <= 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                        to: "farms",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                            width: [
                                "100%",
                                null,
                                null,
                                "auto"
                            ],
                            variant: "secondary",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "primary",
                                    bold: true,
                                    children: t("Start earning")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                    ml: "4px",
                                    color: "primary"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        width: [
                            "100%",
                            null,
                            null,
                            "auto"
                        ],
                        id: "harvest-all",
                        isLoading: pendingTx,
                        endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                            spin: true,
                            color: "currentColor"
                        }) : null,
                        disabled: pendingTx,
                        onClick: harvestAllFarms,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "invertedContrast",
                            bold: true,
                            children: pendingTx ? t("Harvesting") : t("Harvest all")
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var UserBanner_HarvestCard = (HarvestCard);

// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/NoProfileAvatar.tsx
var NoProfileAvatar = __webpack_require__(91905);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/VisibilityOff.tsx
var VisibilityOff = __webpack_require__(11190);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/VisibilityOn.tsx
var VisibilityOn = __webpack_require__(9118);
// EXTERNAL MODULE: ./src/state/profile/hooks.ts + 2 modules
var profile_hooks = __webpack_require__(61491);
// EXTERNAL MODULE: ./src/components/ProfileAvatarWithTeam.tsx
var ProfileAvatarWithTeam = __webpack_require__(32331);
// EXTERNAL MODULE: ../../packages/utils/truncateHash.ts
var truncateHash = __webpack_require__(44203);
// EXTERNAL MODULE: ./src/hooks/useUsernameWithVisibility.ts
var useUsernameWithVisibility = __webpack_require__(85264);
;// CONCATENATED MODULE: ./src/views/Home/components/UserBanner/UserDetail.tsx

function UserDetail_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: none;\n  ",
        " {\n    display: flex;\n  }\n"
    ]);
    UserDetail_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UserDetail_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    UserDetail_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function UserDetail_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 92px;\n  width: 92px;\n  background-color: ",
        ";\n  border: 3px solid ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n"
    ]);
    UserDetail_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function UserDetail_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n"
    ]);
    UserDetail_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var Desktop = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5bb52ca9-0"
})(UserDetail_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var Mobile = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5bb52ca9-1"
})(UserDetail_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var Sticker = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5bb52ca9-2"
})(UserDetail_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.invertedContrast;
}, function(param) {
    var theme = param.theme;
    return theme.colors.invertedContrast;
}, function(param) {
    var theme = param.theme;
    return theme.radii.circle;
}, function(param) {
    var theme = param.theme;
    return theme.card.boxShadow;
});
var StyledNoProfileAvatarIcon = (0,styled_components_browser_esm/* default */.ZP)(NoProfileAvatar/* default */.Z).withConfig({
    componentId: "sc-5bb52ca9-3"
})(UserDetail_templateObject3());
var UserDetail = function() {
    var _useProfile = (0,profile_hooks/* useProfile */.Un)(), profile = _useProfile.profile, isLoading = _useProfile.isLoading;
    var t = (0,src/* useTranslation */.$G)().t;
    var _useAccount = (0,wagmi_esm/* useAccount */.mA)(), account = _useAccount.address;
    var _useMatchBreakpoints = (0,useMatchBreakpoints/* default */.Z)(), isMobile = _useMatchBreakpoints.isMobile, isTablet = _useMatchBreakpoints.isTablet, isDesktop = _useMatchBreakpoints.isDesktop;
    var _useGetUsernameWithVisibility = (0,useUsernameWithVisibility/* default */.Z)(profile), usernameWithVisibility = _useGetUsernameWithVisibility.usernameWithVisibility, userUsernameVisibility = _useGetUsernameWithVisibility.userUsernameVisibility, setUserUsernameVisibility = _useGetUsernameWithVisibility.setUserUsernameVisibility;
    var toggleUsernameVisibility = function() {
        setUserUsernameVisibility(!userUsernameVisibility);
    };
    var Icon = userUsernameVisibility ? VisibilityOff/* default */.Z : VisibilityOn/* default */.Z;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (isTablet || isDesktop) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Desktop, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.ZP, {
                        mr: "24px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Sticker, {
                            children: profile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatarWithTeam/* default */.Z, {
                                profile: profile
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNoProfileAvatarIcon, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        children: [
                            profile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                                scale: "xl",
                                children: [
                                    t("Hi, %userName%!", {
                                        userName: usernameWithVisibility
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                        ml: "4px",
                                        onClick: toggleUsernameVisibility,
                                        cursor: "pointer"
                                    })
                                ]
                            }) : isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                width: 200,
                                height: 40,
                                my: "4px"
                            }) : null,
                            isLoading || !account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                width: 160,
                                height: 16,
                                my: "4px"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                fontSize: "16px",
                                children: [
                                    " ",
                                    t("Connected with %address%", {
                                        address: (0,truncateHash/* default */.Z)(account)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile, {
                children: profile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                    mb: "18px",
                    textAlign: "center",
                    children: [
                        t("Hi, %userName%!", {
                            userName: usernameWithVisibility
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            ml: "4px",
                            onClick: toggleUsernameVisibility,
                            cursor: "pointer"
                        })
                    ]
                }) : isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    width: 120,
                    height: 20,
                    mt: "2px",
                    mb: "18px"
                }) : null
            })
        ]
    });
};
/* harmony default export */ var UserBanner_UserDetail = (UserDetail);

;// CONCATENATED MODULE: ./src/views/Home/components/UserBanner/index.tsx

function UserBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px ",
        " solid;\n  border-left: 1px ",
        " solid;\n  border-right: 1px ",
        " solid;\n  border-radius: ",
        ";\n  background: ",
        ";\n"
    ]);
    UserBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var UserBanner_StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.ZP).withConfig({
    componentId: "sc-5a24e908-0"
})(UserBanner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.secondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.secondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.secondary;
}, function(param) {
    var theme = param.theme;
    return "0 0 ".concat(theme.radii.card, " ").concat(theme.radii.card);
}, function(param) {
    var theme = param.theme;
    return theme.isDark ? "linear-gradient(360deg, rgba(49, 61, 92, 0.9) 0%, rgba(61, 42, 84, 0.9) 100%)" : "linear-gradient(180deg, rgba(202, 194, 236, 0.9) 0%,  rgba(204, 220, 239, 0.9) 51.04%, rgba(206, 236, 243, 0.9) 100%)";
});
var UserBanner = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserBanner_StyledCard, {
        p: [
            "16px",
            null,
            null,
            "24px"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            alignItems: "center",
            justifyContent: "center",
            flexDirection: [
                "column",
                null,
                null,
                "row"
            ],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    flex: "1",
                    mr: [
                        null,
                        null,
                        null,
                        "32px"
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserBanner_UserDetail, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    flex: "1",
                    width: [
                        "100%",
                        null,
                        "auto"
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserBanner_HarvestCard, {})
                })
            ]
        })
    });
};
/* harmony default export */ var components_UserBanner = (UserBanner);

;// CONCATENATED MODULE: ./src/views/Home/index.tsx


function Home_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 16px;\n  margin-top:-20px;\n\n  ",
        " {\n    padding-top: 48px;\n  }\n"
    ]);
    Home_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Home_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 1;\n  position: absolute;\n  width: 100%;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, 0);\n  padding-left: 0px;\n  padding-right: 0px;\n\n  ",
        " {\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n"
    ]);
    Home_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















// import WinSection from './components/WinSection'
// import FarmsPoolsRow from './components/FarmsPoolsRow'
// import Footer from './components/Footer' 



// import MultipleBanner from './components/Banners/MultipleBanner'
var StyledHeroSection = (0,styled_components_browser_esm/* default */.ZP)(PageSection/* default */.Z).withConfig({
    componentId: "sc-25770b73-0"
})(Home_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var UserBannerWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-25770b73-1"
})(Home_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var Home = function() {
    var theme = (0,useTheme/* default */.ZP)().theme;
    var _useAccount = (0,wagmi_esm/* useAccount */.mA)(), account = _useAccount.address;
    var chainId = (0,useActiveChainId/* useActiveChainId */.g)().chainId;
    var HomeSectionContainerStyles = {
        margin: "0",
        width: "100%",
        maxWidth: "968px"
    };
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* PageMeta */.V, {}),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "2ed0c2f7717ef609",
                children: '#home-1 .page-bg{background-image:-webkit-linear-gradient(left,#d9f4ffb8,#ffffff29),url(/images/home/images/slider.png);background-image:-moz-linear-gradient(left,#d9f4ffb8,#ffffff29),url(/images/home/images/slider.png);background-image:-o-linear-gradient(left,#d9f4ffb8,#ffffff29),url(/images/home/images/slider.png);background-image:linear-gradient(to right,#d9f4ffb8,#ffffff29),url(/images/home/images/slider.png)}[data-theme="dark"] #home-1 .page-bg{background-image:-webkit-linear-gradient(left,#000000d1,#314c5896),url(/images/home/images/slider.png);background-image:-moz-linear-gradient(left,#000000d1,#314c5896),url(/images/home/images/slider.png);background-image:-o-linear-gradient(left,#000000d1,#314c5896),url(/images/home/images/slider.png);background-image:linear-gradient(to right,#000000d1,#314c5896),url(/images/home/images/slider.png)}#home-2 .page-bg{background:-webkit-linear-gradient(top,#09070c 22%,#201335 100%);background:-moz-linear-gradient(top,#09070c 22%,#201335 100%);background:-o-linear-gradient(top,#09070c 22%,#201335 100%);background:linear-gradient(180deg,#09070c 22%,#201335 100%)}[data-theme="dark"] #home-2 .page-bg{background:-webkit-linear-gradient(top,#09070c 22%,#201335 100%);background:-moz-linear-gradient(top,#09070c 22%,#201335 100%);background:-o-linear-gradient(top,#09070c 22%,#201335 100%);background:linear-gradient(180deg,#09070c 22%,#201335 100%)}#home-3 .page-bg{background:-webkit-linear-gradient(top,#6fb6f1 0%,#eaf2f6 100%);background:-moz-linear-gradient(top,#6fb6f1 0%,#eaf2f6 100%);background:-o-linear-gradient(top,#6fb6f1 0%,#eaf2f6 100%);background:linear-gradient(180deg,#6fb6f1 0%,#eaf2f6 100%)}[data-theme="dark"] #home-3 .page-bg{background:-webkit-linear-gradient(top,#0b4576 0%,#091115 100%);background:-moz-linear-gradient(top,#0b4576 0%,#091115 100%);background:-o-linear-gradient(top,#0b4576 0%,#091115 100%);background:linear-gradient(180deg,#0b4576 0%,#091115 100%)}#home-4{background:-webkit-linear-gradient(6.45deg,#0653b0 14.95%,#56d6e2 84.15%);background:-moz-linear-gradient(6.45deg,#0653b0 14.95%,#56d6e2 84.15%);background:-o-linear-gradient(6.45deg,#0653b0 14.95%,#56d6e2 84.15%);background:linear-gradient(83.55deg,#0653b0 14.95%,#56d6e2 84.15%)}#home-4 ::before{opacity:.1;content:"";height:100%;width:100%;background-image:url("/images/home/images/registration-bg.png");position:absolute;top:0px;left:0px;right:0px;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;background-repeat:no-repeat;background-position:top center}#home-4 .inner-wedge svg{fill:#d8cbed}#home-5{background-color:#10102d!important}#home-5 ::before{opacity:.1;content:"";height:100%;width:100%;background-image:url("/images/home/images/earn-bg.png");position:absolute;top:0px;left:0px;right:0px;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;background-repeat:no-repeat;background-position:top center}[data-theme="dark"] #home-4 .inner-wedge svg{fill:#201335}'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroSection, {
                innerProps: {
                    style: {
                        margin: "0",
                        width: "100%"
                    }
                },
                containerProps: {
                    id: "home-1"
                },
                index: 2,
                hasCurvedDivider: false,
                children: [
                    account && chainId === swap_sdk_dist/* ChainId.BSC */.a_.BSC && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserBannerWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserBanner, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Hero, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                innerProps: {
                    style: {
                        margin: "0",
                        width: "100%"
                    }
                },
                containerProps: {
                    id: "home-2"
                },
                index: 2,
                hasCurvedDivider: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsSection, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageSection/* default */.Z, {
                innerProps: {
                    style: HomeSectionContainerStyles
                },
                containerProps: {
                    id: "home-4"
                },
                index: 2,
                hasCurvedDivider: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OuterWedgeWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerWedgeWrapper, {
                            top: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WedgeTopLeft, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SalesSection, (0,src_object_spread/* default */.Z)({}, swapSectionData(t)))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                innerProps: {
                    style: HomeSectionContainerStyles
                },
                // background={theme.colors.gradientCardHeader}
                index: 2,
                hasCurvedDivider: false,
                containerProps: {
                    id: "home-5"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SalesSection, (0,src_object_spread/* default */.Z)({}, earnSectionData(t)))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                innerProps: {
                    style: HomeSectionContainerStyles
                },
                containerProps: {
                    id: "home-4"
                },
                index: 2,
                hasCurvedDivider: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SalesSection, (0,src_object_spread/* default */.Z)({}, rateSectionData(t)))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageSection/* default */.Z, {
                innerProps: {
                    style: HomeSectionContainerStyles
                },
                background: theme.colors.background,
                index: 2,
                hasCurvedDivider: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SalesSection, (0,src_object_spread/* default */.Z)({}, cakeSectionData(t))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CakeDataRow, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var views_Home = (Home);

;// CONCATENATED MODULE: ./src/pages/index.tsx



var IndexPage = function(param) {
    var totalTx30Days = param.totalTx30Days, addressCount30Days = param.addressCount30Days, tvl = param.tvl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SWRConfig */.J$, {
        value: {
            fallback: {
                totalTx30Days: totalTx30Days,
                addressCount30Days: addressCount30Days,
                tvl: tvl
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(views_Home, {})
    });
};
IndexPage.chains = [];
var __N_SSG = true;
/* harmony default export */ var pages = (IndexPage);


/***/ }),

/***/ 71446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87014);
/* harmony import */ var hooks_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84252);







var ColoredWordHeading = function(_param) {
    var text = _param.text, firstColor = _param.firstColor, _param_mb = _param.mb, mb = _param_mb === void 0 ? "24px" : _param_mb, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "firstColor",
        "mb"
    ]);
    var theme = (0,hooks_useTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)().theme;
    var _useMemo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var split = text.split(" ");
        var first = split[0];
        var remaining = split.slice(1).join(" ");
        return {
            firstWord: first,
            remainingWords: remaining
        };
    }, [
        text
    ]), firstWord = _useMemo.firstWord, remainingWords = _useMemo.remainingWords;
    var _theme_colors_firstColor;
    var displayedColor = (_theme_colors_firstColor = theme.colors[firstColor]) !== null && _theme_colors_firstColor !== void 0 ? _theme_colors_firstColor : theme.colors.secondary;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        scale: "xl",
        mb: mb
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                style: {
                    color: displayedColor
                },
                children: [
                    firstWord,
                    " "
                ]
            }),
            remainingWords
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ColoredWordHeading);


/***/ }),

/***/ 2076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ SlideSvgDark; },
/* harmony export */   "s": function() { return /* binding */ SlideSvgLight; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39017);




var SlideSvgLight = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        viewBox: "0 0 1660 339"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M804 167.023C520.5 167.023 267.5 290.522 0 304.5V339H1660V0.5C1358.83 0.5 1104 167.023 804 167.023Z",
                fill: "url(#paint0_linear_light)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                    id: "paint0_linear_light",
                    x1: "830",
                    y1: "84",
                    x2: "830",
                    y2: "339",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            stopColor: "white",
                            stopOpacity: "0.48"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "0.566389",
                            stopColor: "white",
                            stopOpacity: "0.35"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "1",
                            stopColor: "white"
                        })
                    ]
                })
            })
        ]
    }));
};
var SlideSvgDark = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        viewBox: "0 0 1660 339"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M804 166.523C520.5 166.523 267.5 290.022 0 304V338.5H1660V0C1358.83 0 1104 166.523 804 166.523Z",
                fill: "url(#paint0_linear_dark)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                    id: "paint0_linear_dark",
                    x1: "830",
                    y1: "83.5",
                    x2: "830",
                    y2: "338.5",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            stopColor: "#08060B",
                            stopOpacity: "0.2"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "0.545554",
                            stopColor: "#08060B",
                            stopOpacity: "0.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "1",
                            stopColor: "#08060B"
                        })
                    ]
                })
            })
        ]
    }));
};


/***/ }),

/***/ 53442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(3411);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(78545);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(22175);
;// CONCATENATED MODULE: ../../packages/uikit/src/components/Card/StyledCard.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    background-position: 50% 0%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 3s ease infinite;\n      background-size: 400% 400%;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  overflow: hidden;\n  position: relative;\n\n  ",
        "\n\n  padding: 1px 1px 3px 1px;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  overflow: ",
        ";\n  background: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var PromotedGradient = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
/**
 * Priority: Warning --> Success --> Active
 */ var getBorderColor = function(param) {
    var isActive = param.isActive, isSuccess = param.isSuccess, isWarning = param.isWarning, borderBackground = param.borderBackground, theme = param.theme;
    if (borderBackground) {
        return borderBackground;
    }
    if (isWarning) {
        return theme.colors.warning;
    }
    if (isSuccess) {
        return theme.colors.success;
    }
    if (isActive) {
        return "linear-gradient(180deg, ".concat(theme.colors.primaryBright, ", ").concat(theme.colors.secondary, ")");
    }
    return theme.colors.cardBorder;
};
var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eecfaa46-0"
})(_templateObject2(), getBorderColor, function(param) {
    var theme = param.theme;
    return theme.radii.card;
}, function(param) {
    var theme = param.theme, isDisabled = param.isDisabled;
    return theme.colors[isDisabled ? "textDisabled" : "text"];
}, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), PromotedGradient);
}, index_esm/* space */.Dh);
var StyledCardInner = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.ZP).withConfig({
    componentId: "sc-eecfaa46-1"
})(_templateObject3(), function(param) {
    var hasCustomBorder = param.hasCustomBorder;
    return hasCustomBorder ? "initial" : "inherit";
}, function(param) {
    var theme = param.theme, background = param.background;
    return background !== null && background !== void 0 ? background : theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
StyledCard.defaultProps = {
    isActive: false,
    isSuccess: false,
    isWarning: false,
    isDisabled: false
};

;// CONCATENATED MODULE: ../../packages/uikit/src/components/Card/Card.tsx






var Card = function(_param) {
    var ribbon = _param.ribbon, children = _param.children, background = _param.background, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ribbon",
        "children",
        "background"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardInner, {
            background: background,
            hasCustomBorder: !!props.borderBackground,
            children: [
                ribbon,
                children
            ]
        })
    }));
};
/* harmony default export */ var Card_Card = (Card);


/***/ }),

/***/ 91905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3411);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39017);






var Icon = function(props) {
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .Fg)();
    var primaryColor = theme.isDark ? "#3C3742" : "#e9eaeb";
    var secondaryColor = theme.isDark ? "#666171" : "#bdc2c4";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 32 32"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z",
                fill: primaryColor
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "A",
                "mask-type": "alpha",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "32",
                height: "32",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z",
                    fill: "#c4c4c4"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                mask: "url(#A)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M25.128 16.436c0 3.115-4.133 5.641-9.231 5.641s-9.231-2.526-9.231-5.641V15h18.461v1.436zm2.205 13.806c0-3.815-5.074-6.908-11.333-6.908S4.667 26.426 4.667 30.242V32h22.667v-1.759z",
                        fill: secondaryColor
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M10.234 5.601C9.942 4.264 10.96 3 12.328 3c1.184 0 2.143.959 2.143 2.143v3.873l1.427-.067c.589 0 1.166.034 1.724.098V5.143c0-1.184.959-2.143 2.143-2.143 1.368 0 2.386 1.264 2.093 2.601l-.931 4.258c2.529 1.006 4.201 2.749 4.201 4.731 0 3.115-4.133 5.641-9.231 5.641s-9.231-2.526-9.231-5.641c0-2.053 1.794-3.849 4.476-4.836l-.908-4.153z",
                        fill: secondaryColor
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                        cx: "12.308",
                        cy: "14.846",
                        rx: "1.026",
                        ry: "1.538",
                        fill: primaryColor
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                        cx: "19.385",
                        cy: "14.846",
                        rx: "1.026",
                        ry: "1.538",
                        fill: primaryColor
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 11190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39017);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 6.49999C14.76 6.49999 17 8.73999 17 11.5C17 12.01 16.9 12.5 16.76 12.96L19.82 16.02C21.21 14.79 22.31 13.25 23 11.49C21.27 7.10999 17 3.99999 12 3.99999C10.73 3.99999 9.51 4.19999 8.36 4.56999L10.53 6.73999C11 6.59999 11.49 6.49999 12 6.49999ZM2.71 3.15999C2.32 3.54999 2.32 4.17999 2.71 4.56999L4.68 6.53999C3.06 7.82999 1.77 9.52999 1 11.5C2.73 15.89 7 19 12 19C13.52 19 14.97 18.7 16.31 18.18L19.03 20.9C19.42 21.29 20.05 21.29 20.44 20.9C20.83 20.51 20.83 19.88 20.44 19.49L4.13 3.15999C3.74 2.76999 3.1 2.76999 2.71 3.15999ZM12 16.5C9.24 16.5 7 14.26 7 11.5C7 10.73 7.18 9.99999 7.49 9.35999L9.06 10.93C9.03 11.11 9 11.3 9 11.5C9 13.16 10.34 14.5 12 14.5C12.2 14.5 12.38 14.47 12.57 14.43L14.14 16C13.49 16.32 12.77 16.5 12 16.5ZM14.97 11.17C14.82 9.76999 13.72 8.67999 12.33 8.52999L14.97 11.17Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 9118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39017);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 16.5C9.24 16.5 7 14.26 7 11.5C7 8.74 9.24 6.5 12 6.5C14.76 6.5 17 8.74 17 11.5C17 14.26 14.76 16.5 12 16.5ZM12 8.5C10.34 8.5 9 9.84 9 11.5C9 13.16 10.34 14.5 12 14.5C13.66 14.5 15 13.16 15 11.5C15 9.84 13.66 8.5 12 8.5Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8421,662,4995,9774,2888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);